import React from 'react'
import PropTypes from 'prop-types'

import { getHeadlineData } from './helpers'

const HeadlinesSectionPreview = ({ data }) => {
  const { assets } = data
  const headlineData = getHeadlineData(assets)

  if (!headlineData || !headlineData.length) {
    return null
  }

  return (
    <p>
      {headlineData.map(({ asset_data }, index) => (
        <span key={index}>{asset_data.text_asset.text}</span>
      ))}
    </p>
  )
}

HeadlinesSectionPreview.propTypes = {
  data: PropTypes.object
}

export default HeadlinesSectionPreview
